import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.classList.remove('hidden')
      this.element.classList.add('opacity-100')
    }, 2000)
  }

  async accept() {
    this.element.classList.remove('opacity-100')
    this.element.classList.add('opacity-0')

    await post('/accept-cookies')

    setTimeout(() => {
      this.element.remove()
    }, 150)
  }
}
